export default {
  meta: {
    title: '竞品调研',
  },
};
